module.exports = __webpack_public_path__ + "img/16.b5a15d0.png";